import { WifiOff, RotateCcw } from "lucide-react";

export function LoadError({ message, onRetry, testId = "load-error" }) {
  return (
    <div className="flex items-center justify-center py-16 px-4" data-testid={testId}>
      <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8 max-w-md w-full text-center">
        <WifiOff className="w-9 h-9 mx-auto text-amber-400" strokeWidth={1.5} />
        <div className="font-display text-lg text-slate-50 mt-4">Não foi possível carregar</div>
        <p className="text-slate-400 text-sm mt-2">
          {message || "O servidor não respondeu a tempo. Verifique a ligação e tente novamente."}
        </p>
        {onRetry && (
          <button
            data-testid={`${testId}-retry`}
            onClick={onRetry}
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-sky-500 hover:bg-sky-400 text-slate-950 px-4 py-2 text-sm font-medium transition-colors"
          >
            <RotateCcw className="w-4 h-4" /> Tentar novamente
          </button>
        )}
      </div>
    </div>
  );
}

export default LoadError;
